// Generated by CoffeeScript 2.7.0
var PopoverGroupOptionsSelect;

import SearchMixin from 'trunks/vue/admin/components/search/mixin.js';

import {
  PopoverGroupOptionsMixin
} from 'trunks/vue/admin/components/popover_group_options.js';

export default PopoverGroupOptionsSelect = Vue.extend({
  mixins: [PopoverGroupOptionsMixin, SearchMixin],
  props: {
    extendClass: {
      type: String
    },
    remote: {
      type: String,
      required: true
    },
    initialSelectedOptions: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      selectedOptions: this.initialSelectedOptions
    };
  },
  template: `<Popover position='bottom'
         type='select'
         size='large'
         :caret='false'
         :blockContent='true'
         :manualToggle='true'
         :customClass='extendClass'
         @triggerClicked='triggerClicked'
         ref='popoverVm'>
  <template slot='trigger'>
    <slot name='trigger' :options='initialSelectedOptions'>
    </slot>
  </template>
  <template slot='content'>
    <popover-group-options :wrapperClass="group_options_extend_class"
                           optionsFilterPlaceholder='搜索'
                           :initialSelectedOptionIds='selectedOptionIds'
                           :formatDataFunc='formatUsers'
                           ref='popoverGroupOptionsRef'
                           @cancelClicked='closeFunc'
                           @submitClicked='submitFunc'
                           @optionsChanged='optionsChangedFunc'
                           @valueChanged='valueChangedFunc'
                           @keywordUpdated='keywordUpdatedFunc'>
      <template slot='option-item-template' slot-scope='{ option }'>
        <slot name='option-item-template' :option='option'>
        </slot>
      </template>

      <div slot='filter-blankslate' class='list-group'>
        <slot name='filter-blankslate'></slot>
      </div>

      <div slot='options-blankslate' class='list-group'>
        <slot name='options-blankslate'></slot>
      </div>
    </popover-group-options>
  </template>
</Popover>`,
  watch: {
    initialSelectedOptions: function(newValue) {
      var ref;
      this.selectedOptions = newValue;
      return (ref = this.$refs.popoverGroupOptionsRef) != null ? ref.selectedOptionsChanged(this.selectedOptionIds) : void 0;
    }
  },
  computed: {
    selectedOptionIds: function() {
      return _.pluck(this.selectedOptions, 'id');
    },
    group_options_extend_class: function() {
      return `${this.extendClass}-edit-container`;
    }
  },
  methods: {
    triggerClicked: function() {
      return this.$refs.popoverVm.open();
    },
    formatUsers: function() {
      return [];
    },
    valueChangedFunc: function(new_option) {
      if (_.contains(this.selectedOptionIds, new_option.id)) {
        new_option._selected = false;
        return this.selectedOptions = [];
      } else {
        _.each(this.$refs.popoverGroupOptionsRef.groupedOptions, function(group) {
          return _.each(group.options, function(option) {
            return option._selected = false;
          });
        });
        new_option._selected = true;
        return this.selectedOptions = [new_option];
      }
    },
    keywordUpdatedFunc: function(keyword) {
      if (_.isEmpty(keyword)) {
        return this.$refs.popoverGroupOptionsRef.updateGroupedOptions([]);
      } else {
        return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.generateUrlWithParams(this.remote, {
          name: keyword
        }), {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          success: (data, xhr) => {
            var options;
            options = data.data ? data.data : data;
            return this.$refs.popoverGroupOptionsRef.updateGroupedOptions([
              {
                id: Skylark.Helpers.Utilities.uuid(),
                options: _.each(options,
              (option) => {
                  return option._selected = _.contains(this.selectedOptions,
              option.id);
                })
              }
            ]);
          }
        });
      }
    },
    closeFunc: function() {
      this.reset();
      return this.$refs.popoverVm.close();
    },
    submitFunc: function() {
      this.$emit('submitClicked', this.selectedOptions);
      return this.closeFunc();
    }
  }
});
